/* ---------- UI Utilities ---------- */
import { Config } from "../../services/config";

export const isThenable = <T,>(v: any): v is Promise<T> => v?.then instanceof Function;

export const safeText = (s?: string | null) => (s ?? "").trim();

export const createOption = (value: string, text: string) => {
  const opt = document.createElement("option");
  opt.value = value;
  opt.textContent = text;
  return opt;
};

export const clearOptions = (sel: HTMLSelectElement) => (sel.options.length = 0);

export function debounce<T extends (...args: any[]) => void>(fn: T, delay = Config.UI.DEBOUNCE_DELAY_MS): T {
  let t: number | undefined;
  return function (this: any, ...args: any[]) {
    if (t) clearTimeout(t);
    t = window.setTimeout(() => fn.apply(this, args), delay);
  } as T;
}
